<hlm-dialog-header>
  <h3 class="paragraph-large-medium" hlmDialogTitle>Supprimer {{ sequence.nom }}</h3>
</hlm-dialog-header>

<div class="py-6">
  <div class="flex flex-col items-center gap-2">
    <span class="paragraph-large-semibold">{{ sequence.nom }}</span>
    <div class="paragraph-medium-medium flex gap-6">
      <span>
        <ng-icon name="lucideLayoutDashboard" hlm size="xs" />
        Liée au {{ module()?.nom }}
      </span>
      <span>
        <ng-icon name="lucideNotebookText" hlm size="xs" />
        {{ sequence.activites?.length }} activités liées
      </span>
    </div>
  </div>
  <hlm-separator class="my-4" />
  <div class="mx-8 flex flex-col gap-6">
    <app-alerte title="Attention, la suppression est irréversible." message="" type="negative" />
    <div>
      <p>
        Êtes-vous sûr de vouloir supprimer la séquence <span class="font-bold">{{ sequence.nom }}</span> ?
      </p>
      <p>La séquence ne sera plus liée au module et les activités qui y étaient liées ne le seront plus.</p>
    </div>
    <div class="flex flex-col gap-1">
      <span>Écrivez <span class="font-bold">SUPPRIMER</span> pour confirmer la suppression.</span>
      <input [(ngModel)]="supprimer" hlmInput type="text" placeholder='Écrivez "SUPPRIMER" en majuscule.' />
    </div>
  </div>
</div>

<hlm-dialog-footer>
  <div class="flex w-full flex-col">
    <hlm-separator />
    <button
      class="m-4"
      [disabled]="supprimer() !== CONFIRMATION_SUPPRESSION_TEXTE"
      (click)="close()"
      hlmBtn
      variant="destructive"
    >
      Je comprends les conséquences, supprimer la séquence
    </button>
  </div>
</hlm-dialog-footer>
